"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.D_ATTrafficEvent = exports.ATTrafficEvent = void 0;
var _commonLib = require("@caps-mobile/common-lib");
var _ATLocation = require("./ATLocation");
var _ATLaneDirection = require("./ATLaneDirection");
var _enums = require("./enums");
var _defaults = require("../../defaults");
var _ATSignStyle = _interopRequireDefault(require("./ATSignStyle"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/******************************************************************************
    CLASS / MODEL
 *****************************************************************************/
var ATTrafficEvent = /*#__PURE__*/function () {
  function ATTrafficEvent() {
    var dto = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : D_ATTrafficEvent;
    _classCallCheck(this, ATTrafficEvent);
    _defineProperty(this, "id", void 0);
    _defineProperty(this, "responsibleRegion", void 0);
    _defineProperty(this, "severity", void 0);
    _defineProperty(this, "type", void 0);
    _defineProperty(this, "start", void 0);
    _defineProperty(this, "end", void 0);
    _defineProperty(this, "lastUpdatedAt", void 0);
    _defineProperty(this, "title", void 0);
    _defineProperty(this, "signStyle", void 0);
    _defineProperty(this, "subTitle", void 0);
    _defineProperty(this, "shortSubTitle", void 0);
    _defineProperty(this, "description", void 0);
    _defineProperty(this, "startLocation", void 0);
    _defineProperty(this, "endLocation", void 0);
    _defineProperty(this, "laneDirections", void 0);
    _defineProperty(this, "active", void 0);
    this.id = dto.id;
    this.responsibleRegion = dto.responsibleRegion;
    this.severity = dto.severity;
    this.type = dto.type;
    this.start = dto.start;
    this.end = dto.end;
    this.lastUpdatedAt = dto.lastUpdatedAt;
    this.title = dto.title;
    this.signStyle = dto.signStyle ? new _ATSignStyle.default(dto.signStyle) : new _ATSignStyle.default();
    this.subTitle = dto.subTitle;
    this.shortSubTitle = dto.shortSubTitle;
    this.description = dto.description;
    this.startLocation = dto.startLocation ? new _ATLocation.ATLocation(dto.startLocation) : new _ATLocation.ATLocation();
    this.endLocation = dto.endLocation ? new _ATLocation.ATLocation(dto.endLocation) : new _ATLocation.ATLocation();
    this.laneDirections = dto.laneDirections ? dto.laneDirections.map(function (direction) {
      return new _ATLaneDirection.ATLaneDirection(direction);
    }) : [];
    this.active = dto.active;
  }
  _createClass(ATTrafficEvent, [{
    key: "isEqual",
    value: function isEqual(object) {
      // -this- is an obejct, so if comparing to undefined, must be non-equal
      if (!object) return false;else return this.id === object.id && this.responsibleRegion === object.responsibleRegion && this.severity === object.severity && this.type === object.type && this.start === object.start && this.end === object.end && this.lastUpdatedAt === object.lastUpdatedAt && this.title === object.title && this.signStyle.isEqual(object.signStyle) && this.description === object.description && this.startLocation.isEqual(object.startLocation) && this.endLocation.isEqual(object.endLocation) && (0, _commonLib.arraysAreEqual)(this.laneDirections, object.laneDirections) && this.severity === object.severity && this.active === object.active;
    }
  }]);
  return ATTrafficEvent;
}();
exports.ATTrafficEvent = ATTrafficEvent;
;

/******************************************************************************
    DEFAULT OBJECT
 *****************************************************************************/
var D_ATTrafficEvent = new ATTrafficEvent({
  id: _defaults.UNKNOWN_OBJECT_ID,
  responsibleRegion: _enums.EATRegion.Unknown,
  severity: _enums.EATSeverity.Uknown,
  type: _enums.EATEventType.Unknown,
  start: _defaults.UNKNOWN_STRING,
  end: _defaults.UNKNOWN_STRING,
  lastUpdatedAt: _defaults.UNKNOWN_STRING,
  title: _defaults.UNKNOWN_STRING,
  signStyle: new _ATSignStyle.default(),
  subTitle: _defaults.UNKNOWN_STRING,
  description: _defaults.UNKNOWN_STRING,
  startLocation: new _ATLocation.ATLocation(),
  endLocation: new _ATLocation.ATLocation(),
  laneDirections: [],
  active: false
});
exports.D_ATTrafficEvent = D_ATTrafficEvent;
var _default = ATTrafficEvent;
exports.default = _default;